/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";


export function HeaderMenu({ layoutProps }) {
    const location = useLocation();
    const { user } = useSelector((state) => state.auth);
    const getMenuItemActive = (url) => {
        return checkIsActive(location, url) ? "menu-item-active" : "";
    }

    return <div
        id="kt_header_menu"
        className={`header-menu header-menu-mobile ${layoutProps.ktMenuClasses}`}
        {...layoutProps.headerMenuAttributes}
    >
       <div className="mt-5">
            <h5 className="text-dark font-weight-bold my-2">{user.schoolName}</h5>
        </div>
    </div>;
}